import * as React from 'react';
import { Suspense, VFC } from 'react';
import { MonacoDiffViewProps } from './MonacoDiffView';
import { MonacoLoading } from './MonacoLoading';
import lazyRetry from '../../../lazyRetry';

const LoadableEditor = lazyRetry(() => import('./MonacoDiffView'), 'MonacoDiffView');

const LoadableMonacoDiff: VFC<MonacoDiffViewProps> = (props) => (
  <Suspense fallback={<MonacoLoading theme={props.theme} />}>
    <LoadableEditor {...props} />
  </Suspense>
);

export default LoadableMonacoDiff;
